import { observable, computed, action } from 'mobx';
import sale from '../../Sale/stores/SaleStore';

import Increase from '../Increase';
import Award from '../Award';
import AwardAll from '../AwardAll';
import Duplicate from '../Duplicate';
import ConfirmAward from '../ConfirmAward';
import Reject from '../RejectSelected';
import RejectAll from '../Reject';
import Counteroffer from '../Counteroffer';
import NotifySeller from '../NotifySeller';

import actionSelector from './actionSelector';

const ACTIONS = {
  increase: { implementation: Increase },
  reject: { implementation: Reject },
  rejectAll: { implementation: RejectAll },
  award: { implementation: Award },
  awardAll: { implementation: AwardAll },
  duplicate: { implementation: Duplicate },
  confirmAward: { implementation: ConfirmAward },
  counteroffer: { implementation: Counteroffer },
  notifySeller: { implementation: NotifySeller },
  edit: {},
  abort: {},
  reset: {},
  close: {},
};

class SaleWizardStore {
  @observable currentAction = '';

  @observable currentStep = 0;

  @observable currentStepValid = true;

  @observable actionStore = {};

  @observable steps = null;

  @observable summaryClass = null;
  @observable resultsClass = null;

  @observable submitting = false;

  source = {};

  @computed get availableActions() {
    const {
      definition: { type, status },
    } = this.source.round;
    return actionSelector({
      sale: this.source,
      round: { type, status },
    }).filter((a) => !!ACTIONS[a].implementation);
  }

  @computed get isInitialStep() {
    return this.currentStep === 0;
  }

  @computed get isConfirmationStep() {
    return this.steps && this.currentStep === this.steps.length + 1;
  }

  @computed get isActionStep() {
    return (
      this.steps &&
      this.currentStep > 0 &&
      this.currentStep <= this.steps.length
    );
  }

  @computed get isResultsStep() {
    return this.steps && this.currentStep === this.steps.length + 2;
  }

  @computed get breadcrumbs() {
    if (!this.steps) {
      return ['Select Action'];
    }

    return [
      'Select Action',
      ...this.steps.map((i) => i.title),
      'Review',
      'Results',
    ];
  }

  @computed get currentActionStep() {
    if (!this.isActionStep) return null;
    return this.steps[this.currentStep - 1].implementation;
  }

  @computed get currentActionInfo() {
    if (!this.isActionStep) return null;
    return this.steps[this.currentStep - 1].info;
  }

  @action currentStepValidChanged(valid) {
    this.currentStepValid = valid;
  }

  @computed get isCurrentStepValid() {
    return !this.currentActionStep || this.currentStepValid;
  }

  @computed get showPrevious() {
    return this.isActionStep || this.isConfirmationStep;
  }

  @computed get showNext() {
    return this.isActionStep && this.isCurrentStepValid;
  }

  @computed get showSubmit() {
    return this.isConfirmationStep;
  }

  constructor({ sale }) {
    this.source = sale;
  }

  handleSelectAction = action((actionKey) => () => {
    this.selectActionByKey(actionKey);
  });

  handleNext = action(() => {
    this.currentStep++;
  });

  handlePrevious = action(() => {
    this.currentStep--;
  });

  handleSubmit = action(async () => {
    this.submitting = true;
    try {
      await this.actionStore.submit(
        this.source.saleId,
        this.source.user.accessToken
      );
      this.currentStep++;
    } finally {
      this.submitting = false;
    }
  });

  selectActionByKey(actionKey) {
    var a = ACTIONS[actionKey];
    if (!a || !a.implementation) return;

    this.currentAction = actionKey;
    this.selectAction(a.implementation);
  }

  selectAction(store) {
    if (!store) {
      return;
    }

    this.currentStep = 1;
    this.actionStore = new store(this);
    this.steps = !!this.actionStore.getSteps
      ? this.actionStore.getSteps()
      : this.actionStore.steps;
    this.summaryClass = this.actionStore.summaryClass;
    this.resultsClass = this.actionStore.resultsClass;
  }
}

const saleWizard = new SaleWizardStore({ sale });

export default saleWizard;
export { SaleWizardStore };



// WEBPACK FOOTER //
// ./src/app/containers/SaleWizard/stores/SaleWizardStore.js